// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_d4-a";
export var fulfillmentFormRail = "_d4-9";
export var headerTitleRow = "_d4-c";
export var orderDetailsWrapper = "_d4-7";
export var orderLinkTrigger = "_d4-2";
export var paymentInformationGrid = "_d4-h";
export var paymentSummaryColumn = "_d4-i";
export var shipmentContainer = "_d4-b";
export var shipmentDetailsMainPane = "_d4-8";
export var shipmentNavigationCard = "_d4-5";
export var shipmentNavigationRail = "_d4-3";
export var shipmentNavigationRailHeader = "_d4-4";
export var shipmentSummaryFact = "_d4-e";
export var shipmentSummaryGrid = "_d4-d";
export var shipmentSummaryMetadataRow = "_d4-f";
export var shipmentSummaryTags = "_d4-g";
export var shipmentWorkspace = "_d4-0";
export var shipmentWorkspaceContent = "_d4-6";
export var shipmentWorkspaceHeader = "_d4-1";